<template>
  <v-dialog v-model="openDialog" fullscreen>
    <v-card class="fullscreen-dialog">
      <v-container>
        <v-row class="payment-container" align="center" justify="center">
          <v-col cols="8 mb-15">

            <h1 v-if="isFullSending && isSendingSuccess" class="white--text mb-7 text-center">SMS enviado com sucesso!</h1>

            <h1 v-else-if="isFullSending && !isSendingSuccess" class="white--text mb-7 text-center">Error ao tentar enviar, tente novamente!</h1>

            <h1 v-if="!isSending && !isFullSending" class="white--text mb-7 text-center">{{!isNewPhone ? 'Digite o seu número cadastrado' : 'Digite um novo número'}}</h1>

            <div v-if="!isSending" class="card text-center mb-16">
              <v-form v-if="!isFullSending && !isSendingSuccess"  ref="form" @submit.prevent="handleSmsSending">

                 <v-text-field 
                    v-show="!isNewPhone"
                    class="input-field mb-11"
                    v-model="phone"
                    @input="onInputChange"  
                    color="black"
                    autofocus 
                    :disabled="disabledTextField"
                    :rules="[() => !!phone || 'Este campo é obrigatório']" 
                    placeholder="(83)99999-0000" 
                    prepend-inner-icon="mdi-cellphone-message" 
                    outlined
                    clearable
                  ></v-text-field>

                 <v-text-field 
                    v-if="isNewPhone"
                    class="input-field mb-11"
                    v-model="phone"
                    @input="onInputChange"  
                    color="black" 
                    autofocus
                    :rules="[() => !!phone || 'Este campo é obrigatório']" 
                    placeholder="(83)99999-0000" 
                    prepend-inner-icon="mdi-cellphone-message" 
                    outlined
                    clearable
                  ></v-text-field>

                <v-btn
                  class="py-6  payment-button" 
                  block 
                  color="primary"
                  type="submit"
                  @click.right="handleSmsSending"
                >
                  <img src="@/assets/ic-login.png" class="mr-2" alt=""> 
                  Confirmar
                </v-btn>

                    <v-btn
                    class="py-6 mt-6 payment-button" 
                    block  
                    color="white"
                    @click="goBack"
                    @click.right="goBack"
                >
                   
                    <v-icon left light color="black" size="24" class="mr-2">mdi-arrow-left</v-icon>
                    Voltar
                </v-btn> 

                <div v-if="hasPhone">
                <v-divider class="my-10"></v-divider>

                  <v-btn
                    class="py-6 payment-button" 
                    block  
                    color="white"
                    @click="handleNewPhone"
                    @click.right="handleNewPhone"
                >
                    <img src="@/assets/ic-login_black.png" class="mr-2" alt="">
                    {{!isNewPhone ? 'Usar outro número' : 'Usar número cadastrado'}}
                </v-btn> 
              
                </div>

                </v-form>

                <div v-else-if="isFullSending && isSendingSuccess">
                  <v-icon left light color="#0CCCA6" size="120" class="pr-4">mdi-cellphone-arrow-down</v-icon>
                  <v-divider class="my-10"></v-divider>
                    <v-btn
                    class="py-6 payment-button" 
                    block  
                    color="primary"
                    @click="goBack"
                    @click.right="goBack"
                   >
                    <v-icon left light color="white" size="24" class="mr-2 icon-arrow">mdi-arrow-left</v-icon>
                      Voltar ao início
                    </v-btn> 
                    <v-btn
                    class="py-6 mt-6 payment-button"
                    color="white"
                    block  
                    @click="userLogout"
                    @click.right="userLogout"
                   >
                    <v-icon left light color="black" size="25" class="mr-2">mdi-exit-to-app</v-icon>
                      Encerrar sessão
                    </v-btn> 
                </div>

                <div v-else-if="isFullSending && !isSendingSuccess">
                  <v-icon left light color="red" size="120" class="mr-2">mdi-cellphone-erase</v-icon>
                  <v-divider class="my-10"></v-divider>
                    <v-btn
                    class="py-6 payment-button" 
                    block  
                    color="white"
                    @click="goBack"
                    @click.right="goBack"
                   >
                    <img src="@/assets/ic-login_black.png" class="mr-2" alt="">
                      Voltar ao início
                    </v-btn> 
                     <v-btn
                    class="py-6 mt-6 payment-button"
                    color="white"
                    block  
                    @click="userLogout"
                    @click.right="userLogout"
                   >
                    <v-icon left light color="black" size="25" class="mr-2">mdi-exit-to-app</v-icon>
                      Encerrar sessão
                    </v-btn> 
                </div>

             <div class="keyboard">
             <NumberKeyboard
              v-if="!isSending && !isSendingSuccess && isNewPhone || !isSending && !isSendingSuccess && !hasPhone"
              @onChange="onChange"
              @onKeyPress="onKeyPress"
              :input="phone"
            />
          </div>     
            </div>

            <div v-else>
              <Loading text="Enviando..."/>
            </div>
         
          </v-col>
          
        </v-row>
      </v-container>
        
    </v-card>
   
  </v-dialog>
</template>

<script>

import NumberKeyboard from '@/NumberKeyboard'

import userStore from "@/store/user.store"
import invoicesStore from "@/store/invoices.store"
import closePageInvoices from "@/store/closePageInvoices.store"

import {signOut} from "@/controllers/user.controller"
import {updateLog} from '@/controllers/user.controller'

import Loading from '@/components/Loading/Loading';

import axios from 'axios';
import config from "@/config.js";

import {getDateAndMonth} from "@/services/date.service"
import {unMaskSpecialChacaracters, maskPhone} from "@/services/unMask.service"
export default {
    name: "SmsDialog",
    components: {Loading, NumberKeyboard},
    props: {
      openDialog: {
        type: Boolean,
        default: false
      },
      handleSmsDialog: {
        type: Function,
        default: response => response
      },
    },
    data () {
      return {
        phone:  '',
        hasPhone: false,
        isNewPhone: false,
        userPhone: '',
        disabledTextField: false,
        isSending: false,
        isFullSending: false,
        isSendingSuccess: false,
        handleSetTimeout: '',
        time: 240000
      }
    },
    methods: {
     onChange(input) {
       if(!this.hasPhone || this.isNewPhone) {
         return this.phone = maskPhone(input) 
       }

      this.phone = input;
    },
    onKeyPress() {
        // params button
    },
    onInputChange(input) {
      this.phone = input?.target.value;
      
    },  
    handleMouse () {
      clearTimeout(this.handleSetTimeout)
      this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
    },  
    handleSetTimeoutOutput () {
      clearTimeout(this.handleSetTimeout)
      signOut()
    },
    goBack () {
      clearTimeout(this.handleSetTimeout)

      this.isFullSending = false
      this.isSendingSuccess = false

      closePageInvoices.commit('setIsToClose', true)

      this.$emit('close', true)
    },
    userLogout () {
      clearTimeout(this.handleSetTimeout)

      signOut()
    },
    async handleSmsSending (e) {
      e.preventDefault()

      if (this.$refs.form.validate()) {
      clearTimeout(this.handleSetTimeout)

      this.isSending = true;

      const phone = unMaskSpecialChacaracters(this.phone)
      
      
      const invoices = invoicesStore.getters.invoices

      try {
        for (const invoice of invoices) {
           const payload = {
           "get_barcode":
            {
              "banking_billet_id": invoice.id,
              "send_barcode": true,
              "cell_phone_number": phone.trim(),
              "return_type": "line",
              "send_content": `A linha digitável referente ao pagamento da fatura de vencimento ${getDateAndMonth(invoice.due_date)}  é: |BARCODE|`
            }
          }
          await axios.post(`${config.urlApiTely}/get_barcode`, payload)
       
          const sleep = m => new Promise(r => setTimeout(r, m))
          await sleep(3000)
        }

        updateLog('smsTransaction')

        this.isSending = false;
        this.isFullSending = true
        this.isSendingSuccess = true

        if (this.isFullSending) {
          this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
        }
 
      } catch (error) {
        console.log(error)

        this.isSending = false;
        this.isFullSending = true
        this.isSendingSuccess = false
      }
    }
      
      
    },
    handleNewPhone () {
      if (!this.isNewPhone) {
        this.isNewPhone = true
        this.disabledTextField = false
        this.phone = '';

        this.handleMouse()

        return
      } 

      this.isNewPhone = false
      this.disabledTextField = true
      this.phone = this.userPhone;

      this.handleMouse()
    },
  },
  mounted () {
    this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
  },
    beforeMount() {
     
      const {telCelular} = userStore.getters.user

      this.userPhone =  telCelular


      if (this.userPhone) {
        this.phone = this.userPhone;
        this.disabledTextField = true
        this.hasPhone = true
      }
  } 
}
</script>

<style scoped>
::v-deep .v-text-field__slot  {
  height: 66px;
  font-size: 21px;
  font-weight: bold;
}
::v-deep .v-input__icon {
  align-self: center;
  font-size: 21px;
  margin-top: 5px;
}
::v-deep .v-messages__message  {
  font-size: 16px;
}
/* .fullscreen-dialog {
    background: rgba(12, 204, 166, 0.6) !important;
    box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4), 0px 0px 32px rgba(35, 41, 46, 0.2) !important;
    backdrop-filter: blur(24px) !important;
    border-radius: 0 !important;
} */

.fullscreen-dialog .payment-container {
    height: 100vh;
}

.fullscreen-dialog .payment-button {
    box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4), 0px 6px 16px rgba(35, 41, 46, 0.2) !important;
    border-radius: 16px !important;
    font-weight: 600 !important;
    font-size: 17px !important;
}

.white--text{
    color: #1A237E !important;
}

h1 {
    font-size: 26px;
    font-weight: 600;
    line-height: 32.76px;
    letter-spacing: 0.15px;
}
.keyboard {
  position: absolute;
  margin: 0 auto;
  width: 100%;
  overflow: hidden;
  bottom: 10%;
  left: 0;
}

.icon-arrow {
  color: white !important;
}
</style>